module.exports = __webpack_public_path__ + "img/thumb_2021-09.e7c38aaa.jpg";